import React from 'react'
import { IonChip, IonCol, IonLabel, IonRow } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import ChipComponent from '../components/Chips.component'

const svgData = [
  {
    id: 'front-extremities',
    label: 'additionalAssessments.bodySurvey.front',
    chips: ['R', 'L'],
    svgPath:
      'M59 2.5L69.5 0L81.5 2.5L90.5 14L88.5 37.5L84 39L81.5 52.5L84 58L104 66.5L116 75L120.5 81L123.5 88V105.5V118.5L127 145L131 158.5L130 190L135 200.5L139.5 215.5L125 223H118.5V203H116L111.5 208.5L109 207L113 198.5L120.5 193L111.5 157.5L113 136.5L103 104L97 122L95 134.5L94 155.5L101.5 166.5V173.5L109 196.5L105 236.5L106.5 246L99.5 274V314.5L103 333.5L87.5 389.5L95.5 403V407.5L84.5 411.5H79L77.5 406L76.5 390.5L81.5 377.5V350.5L77.5 339.5L76.5 326L81.5 310.5L76.5 299.5L80 272L76.5 243V224L73.5 205.5H70H66.5L64 224V243L60.5 272L63 299.5L58.5 310.5L63.5 326L63 339.5L58.5 350.5L59.5 377.5L63.5 390.5V406L61.5 411.5H55.5L44.5 407.5V403L53 389.5L37.5 333.5L39.5 314.5L41 274L34 246L35 236.5L31 196.5L38.5 173.5V166.5L44.5 155.5L46 134.5L43.5 122L37.5 104L26.5 136.5L27.5 157.5L19 193L28 199.5L31 208.5L29.5 209.5L23.5 202L21.5 203V223H14.5L0 215.5L4 200.5L9.5 190L9 157.5L12 145L14 133L16 118.5L17 105.5V88L19.5 81L24.5 75L36.5 66.5L57 58L59 52.5L56 39L52 37.5L50.5 14L59 2.5Z',
  },
  {
    id: 'back-extremities',
    label: 'additionalAssessments.bodySurvey.back',
    chips: ['L', 'R'],
    svgPath:
      'M59 2.5L69.5 0L81.5 2.5L90.5 14L88.5 37.5L84 39L81.5 52.5L84 58L104 66.5L116 75L120.5 81L123.5 88V105.5V118.5L127 145L131 158.5L130 190L135 200.5L139.5 215.5L125 223H118.5V203H116L111.5 208.5L109 207L113 198.5L120.5 193L111.5 157.5L113 136.5L103 104L97 122L95 134.5L94 155.5L101.5 166.5V173.5L109 196.5L105 236.5L104.5 246L99.5 274V314.5L103 333.5L87.5 389.5L95.5 403V407.5L84.5 411.5H79L77.5 406L76.5 390.5L81.5 377.5V350.5L77.5 339.5L76.5 326L81.5 310.5L76.5 299.5L80 272L74.5 243L72.5 224V219L69.5 220L67 219V224V233.5L66 243L60.5 272L63 299.5L58.5 310.5L63.5 326L63 339.5L58.5 350.5L59.5 377.5L63.5 390.5V406L61.5 411.5H55.5L44.5 407.5V403L53 389.5L37.5 333.5L39.5 314.5L41 274L36 246L35 236.5L31 196.5L38.5 173.5V166.5L44.5 155.5L46 134.5L43.5 122L37.5 104L26.5 136.5L27.5 157.5L19 193L28 199.5L31 208.5L29.5 209.5L23.5 202L21.5 203V223H14.5L0 215.5L4 200.5L9.5 190L9 157.5L12 145L14 133L16 118.5L17 105.5V88L19.5 81L24.5 75L36.5 66.5L57 58L59 52.5L56 39L52 37.5L50.5 14L59 2.5Z',
  },
]

const GeneralExtremities: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div id='GeneralExtremitiesSection' className='body-section'>
      {svgData.map((section) => (
        <div key={section.id} id={section.id}>
          <IonChip outline className='body-survey-chip body-survey-chip-size mb-5'>
            <IonLabel className='body-survey-chip-label'>{t(section.label)}</IonLabel>
          </IonChip>
          <IonRow className='image-container mobile-nowrap'>
            <IonCol className='mt-20 left-3'>
              <ChipComponent label={section.chips[0]} />
            </IonCol>
            <IonCol>
              <div className='general-extremities'>
                <svg viewBox='0 0 140 412' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <path d={section.svgPath} fill='var(--ion-color-zoll-gray-blue)' />
                </svg>
              </div>
            </IonCol>
            <IonCol className='mt-20 right-3'>
              <ChipComponent label={section.chips[1]} />
            </IonCol>
          </IonRow>
        </div>
      ))}
    </div>
  )
}

export default GeneralExtremities
